// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"73d7935b","455":"d5b3a034","977":"c914ff1b"}[chunkId] + ".chunk.js";
};